import * as path from "node:path";
import { mkdir, writeFile } from "./lib/fsLimit.js";
const writeProjectFile = async (args) => {
  const filePath = args.helpers.joinPathFromRoot(args.filename);
  let contents = args.contents;
  if (args.format) {
    contents = await args.helpers.format(contents.toString(), filePath, args.formatOptions);
  }
  await mkdir(path.dirname(filePath), { recursive: true });
  await writeFile(filePath, contents);
  return filePath;
};
export {
  writeProjectFile
};
//# sourceMappingURL=writeProjectFile.js.map
